export class OutOfScopeClass {
    constructor() {
        this.id = 0;
        this.duid = "";
    }
}